import type { Contract } from 'validata';
import { isObject } from 'validata';
import { isObjectSet } from 'validata-mongo';
import { TitleEntity } from './common.js';

export namespace Group {
  export const NAME = 'group' as const;

  export interface Type extends TitleEntity.Type {
    invitationCode?: string | null;
    members?: string[] | null;
    admin?: {
      personIds?: string[] | null;
    } | null;
  }

  export const DEFAULTS = {} as const;

  export type Create = Pick<Type, TitleEntity.ModifyProps>;
  export type Patch = Pick<Type, TitleEntity.ModifyProps>;

  export const createContract: Contract<Create> = {
    ...TitleEntity.modifyContract,
  };

  export const create = isObject<Create>(createContract);

  export const patchContract: Contract<Patch> = {
    ...TitleEntity.modifyContract,
  };

  export const patch = isObjectSet<Patch>(patchContract);
}
